export default ["grey", "white", "dark"];
